import URLParamService from "@/services/URLParamService";

export const useIsPromoMini = (): boolean => {
  const queryParams = URLParamService.getQueryParams();
  const mini = queryParams?.mini?.toLowerCase();

  return mini === "true" || mini === "1" || mini === "";
};
